import React from 'react';
import styled from 'styled-components';
import CountInputBtn from '../button/CountInputBtn';
import OptionPriceBtn from '../button/OptionPriceBtn';
import { useDispatch, useSelector } from 'react-redux';
import { setSelOptionInfoAction } from '../../../modules/common/prodModule';
import { findIndex } from 'lodash';
import { isMobileOnly } from 'react-device-detect';

const ProdDetailOptionItemBlock = styled.div`
    padding: 20px 0px 20px 10px;
    border-bottom: 1px solid #cccccc;
    .qty-price {padding-right: 13px;}
`;

const TitleBlock = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: start;
    text-overflow: ellipsis;
    overflow: hidden;
    
    margin-bottom: ${isMobileOnly?"10px":"10px"};
    
    p {
        
      ${isMobileOnly?`
      max-width: 80%;
        font-size: 14px;
        `:`
        max-width: 85%;
        font-size: 14px;
        color: #333333;
        line-height: 1.43;
    `};
    }
`;

const OptionPriceCloseBtnBlock = styled.button`
    //width: 11px;
    //height: 11px;
    //margin-top: 6px;
    //margin-left: 10px;
    background-image: url(${props => props.img || ''});
    background-position: center;
    background-repeat: no-repeat;
    padding: 11px 18px;
`;

const ProdDetailOptionItem = ({ idx, optionInfo, hasOption }) => {

    const dispatch = useDispatch();

    var { selectedOptionItems } = useSelector(
        ({ prodItemsReducer }) => ({
            selectedOptionItems: prodItemsReducer.selectedOptionItems
        })
    );

    const getSecOptString = (title, option) => {

        let resString = '';
        if (title !== null && title !== undefined && option !== null && option !== undefined) {
            resString = ' / ' + title + ':' + option;
        }
        return resString;
    }

    const closeBtnHandler = () => {

        let objIdx = findIndex(selectedOptionItems, (curitem) => {
            return curitem.opt_id === optionInfo.opt_id;
        })

        if (objIdx !== -1) {
            // 옵션 번호가 0 인 항목은 옵션이 없는 것이므로 그냥 리턴
            if (selectedOptionItems[objIdx].opt_id !== 0) {

                selectedOptionItems.splice(objIdx, 1);
                dispatch(setSelOptionInfoAction(selectedOptionItems));
            }
        }
    }

    // Count 갯수 변경
    const changeValueHandler = (value) => {

        let objIdx = findIndex(selectedOptionItems, (curitem) => {
            return curitem.opt_id === optionInfo.opt_id;
        })

        if (objIdx !== -1) {
            selectedOptionItems[objIdx].qty = value;
            selectedOptionItems[objIdx].es_prdct_price = selectedOptionItems[objIdx].es_opt_pirce * value;
            dispatch(setSelOptionInfoAction(selectedOptionItems));
        }
    }

    const getOptionTitle = () => {
        if (optionInfo.opt1 === null || optionInfo.opt1 === '') {
            return (
              <TitleBlock>
                    <p>
                        {optionInfo.opt_nm}
                    </p>
              </TitleBlock>
            )
        }

        return (
          <TitleBlock>
            <p>
                {idx}. {optionInfo.opttitle1} : {optionInfo.opt1}
                {getSecOptString(optionInfo.opttitle2, optionInfo.opt2)}
                {getSecOptString(optionInfo.opttitle3, optionInfo.opt3)}
            </p>
        {hasOption&&<OptionPriceCloseBtnBlock
          img={"/assets/images/icon/pro-close-icon.png"}
          onClick={closeBtnHandler} />}
          </TitleBlock>
        )
    }
    return (
        <ProdDetailOptionItemBlock>
            <div>
                {getOptionTitle()}
                <div className="qty-price clearfix">
                    <CountInputBtn width="32px" height="32px" num={optionInfo.qty}
                        changeValueHandler={changeValueHandler} />
                    <OptionPriceBtn value={optionInfo.es_prdct_price === null ? '0' : optionInfo.es_prdct_price} />
                </div>

            </div>
        </ProdDetailOptionItemBlock>
    );
};

export default ProdDetailOptionItem;
